import {MarketplaceViewType} from "../../marketplace/consts";

export const MarketplaceViewTypeToHebrew = {
    [MarketplaceViewType.selectionPage]: "אתר בחירה",
    [MarketplaceViewType.product]: "מוצר",
    [MarketplaceViewType.link]: "לינק"
};
